<template>
    <section class="container h-100">
        <div class="page-header mt-4 bg-light-gray">

            <div class="row d-flex align-items-center h-100">
                <div class="col-md-12 text-white">
                    <h2 class="h1 text-white">{{pageModel.pageTitle}}</h2>
                    <p class="text-white">{{pageModel.ShortDescription}}</p>
                </div>
            </div>
        </div>
    </section>

    <div class="">
        <div class="container">
            <div class="dynamicContentBody pd-80" v-html="pageModel.pageContent">
            </div>
        </div>
    </div>

    <section class="newsletter" v-if="IsShowNewsletter">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h4>Do you want to subscribe our newsletter?<br> Leave your email and will keep you updated</h4>
                </div>
                <div class="col-lg-6">
                    <Form autocomplete="off" @submit="emailsubmit" :validation-schema="schemaemail" v-slot="{ errors }" class="gx-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="newsletter-label"> Your Email</label>
                                <div class="input-wrapper position-relative">
                                    <div class="input-wrapper-box">
                                        <Field type="text" name="email" v-model="emailvalue"
                                               :class="{ 'is-invalid': errors.email }"
                                               class="form-control" maxlength="50" placeholder="Enter your email" />
                                        <div class="invalid-feedback">{{errors.email}}</div>
                                    </div>
                                    <input type="submit" class="btn newsletter-btn" />
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
        <!-- background shapes -->

    </section>
    <Loading v-model:active="isLoading">
    </Loading>
</template>

<script>
    import service from '../../service/FrontendService.js';;
    import * as Yup from 'yup';
    import { Form, Field } from 'vee-validate';

    export default {
        name: "dynamicPage",
        components: {
            Form, Field
        },
        data() {

            const pageModel = {
                id: null,
                pageTitle: '',
                pageContent: '',
                ShortDescription: ''
            }


            const schemaemail = Yup.object().shape({
                email: Yup.string().required('Email is required').email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid')
            });

            return {
                pageModel,
                PageURL: '',
                IsShowNewsletter: false,
                schemaemail,
                emailvalue: null,
                isLoading: true,
                IsShowHeader: true
            }
        },
        created() {
            this.isLoading = true;
            this.getPageURL();
            this.getDynamicContent();
       
            setTimeout(() => { this.isLoading = false;}, 1000);
        },
        updated() {
            window.scrollTo(0, 0);
            if (this.PageURL == this.$route.name || this.PageURL == this.$route.params.url) {
                return
            }
            else {
                this.getDynamicContent();
                setTimeout(() => { this.isLoading = false; }, 2000);
            }
           
        },
        methods: {
            getDynamicContent() {
                this.getPageURL();
                service.GetDynamicPageContent(this.PageURL).then((response) => {
                    if (response.data.statusCode == 200) {
                        this.isLoading = true;
                        this.pageModel.id = response.data.result.id;
                        this.pageModel.pageTitle = response.data.result.pageTitle;
                        this.pageModel.pageContent = response.data.result.pageDescription;
                        this.pageModel.ShortDescription = response.data.result.shortDescription;
                        debugger;
                        if (this.PageURL == 'Features' || this.PageURL == 'Leasing&Applications') {
                            this.IsShowNewsletter = true; this.IsShowHeader = false
                        } else {
                            this.IsShowNewsletter = false; this.IsShowHeader = true
                        }

                    }
                    else {
                        this.NoContentFound();
                    }
                    //this.isLoading = false;
                }).catch((error) => {
                    this.NoContentFound();
                    console.log('error', error);
                    this.isLoading = false;
                })
            },

            getPageURL() {
                // if PageUrlFromParent is not that means this component is called by anthor function so PageUrlFromParent will be passed in Props
                if (this.$filters.IsNull(this.PageUrlFromParent, true, null) == null) {
                    let routeName = this.$route.name
                    if (routeName == 'dynamicPage') {
                        this.PageURL = this.$route.params['url']

                    } else {
                        this.PageURL = routeName;
                     

                    }
                } else {
                    this.PageURL = this.PageUrlFromParent

                }
            },
            //getPageURL() {
            //    this.PageURL = this.$route.path;
            //   // this.PageURL = this.PageURL.substring(this.PageURL.split('').findIndex((x, i) => { return x == '/' && i > 1 }) + 2, this.PageURL.length);
            //},
            NoContentFound() {
                this.pageModel.id = null;
                this.pageModel.pageTitle = this.PageURL;
                this.pageModel.pageContent = '<H1>No Content Available</h1>';
                this.pageModel.ShortDescription = 'No Content Available';
            },
            async emailsubmit() {
                this.isLoading = true;
                var manageSubscribersModel = {
                    email: this.emailvalue,
                }
                await service.AddSubscriber(manageSubscribersModel).then(Response => {
                    if (Response != null && Response.data.statusCode == 200 || Response.data.statusCode == 201) {
                        this.isLoading = false;
                        if (Response.data.statusCode == 200) {
                            this.$router.push({
                                name: "thankyou",
                                state: {
                                    routeMessage: {
                                        IsSuccess: true,
                                        displayMessage: 'You have successfully joined our subscriber list'
                                    }
                                }
                            }
                            )
                        }
                        else {
                            this.$router.push({
                                name: "thankyou",
                                state: {
                                    routeMessage: {
                                        Email: this.emailvalue,
                                        IsSuccess: false,
                                    }
                                }
                            });
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.error('Bad req')
                    }
                }).catch(res => {
                    this.error("Something went wrong. Please contact site administrator.");
                    this.isLoading = false;
                })
            }
        }
    }
</script>
